class Video {
  constructor(el) {
    this.el = el
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.ui = {}
    this.ui.$mute = this.el.querySelector('.js-mute')
    this.ui.$muteIcon = this.el.querySelector('.js-mute-icon')
    this.ui.$unmuteIcon = this.el.querySelector('.js-unmute-icon')
    this.ui.$video = this.el.querySelector('.js-video')
    this.ui.$playBtn = this.el.querySelector('.js-control')
    this.ui.$playIcon = this.el.querySelector('.js-play-icon')
    this.ui.$pauseIcon = this.el.querySelector('.js-pause-icon')
    this.ui.$transcriptBtn = this.el.querySelector('.js-transcript')
    this.ui.$transcriptPopup = document.querySelector('.js-transcript-popup')
    this.ui.$transcriptClose = document.querySelector('.js-transcript-close')
    this.ui.$transcriptContent = document.querySelector('.js-transcript-content')

    this.isPlaying = false
    this.isMute = true

    if (this.ui.$video.offsetWidth > this.ui.$video.offsetHeight) {
      this.el.classList.add('landscape')
    } else {
      this.el.classList.add('portrait')
    }

    if (this.ui.$transcriptBtn && (!this.ui.$video.getAttribute('data-description') || this.ui.$video.getAttribute('data-description').trim() === '')) {
      this.ui.$transcriptBtn.style.display = 'none'
    }

    this.cacheControlTitleIds()
    this.setAriaDescribedBy()
  }

  cacheControlTitleIds() {
    const playTitle = this.ui.$playBtn?.querySelector('.js-play-icon title')
    const pauseTitle = this.ui.$playBtn?.querySelector('.js-pause-icon title')
    const muteTitle = this.ui.$mute?.querySelector('.js-mute-icon title')
    const unmuteTitle = this.ui.$mute?.querySelector('.js-unmute-icon title')
    this.controlTitleIds = {
      play: playTitle?.id || null,
      pause: pauseTitle?.id || null,
      mute: muteTitle?.id || null,
      unmute: unmuteTitle?.id || null,
    }
  }

  bindEvents() {
    if (this.el.classList.contains('js-card--module')) {
      this.el.addEventListener('click', this.toggle.bind(this))  
    } else {
      this.ui.$mute.addEventListener('click', this.toggle.bind(this))
    }
    this.ui.$playBtn.addEventListener('click', this.playToggle.bind(this))
    if (this.ui.$transcriptBtn && this.ui.$transcriptBtn.style.display !== 'none') {
      this.ui.$transcriptBtn.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        if (!this.ui.$transcriptPopup.classList.contains('animate-in')) {
          this.openTranscript()
        }
      }, true)
    }
    if (this.ui.$transcriptClose) {
      this.ui.$transcriptClose.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.closeTranscript()
      }, true)
    }
  }

  playToggle() {
    if (this.isPlaying) {
      this.pause()
    } else {
      this.play()
    }
  }

  play() {
    this.ui.$video.play()
    this.isPlaying = true
    this.ui.$playIcon.classList.add('u-is-hidden')
    this.ui.$pauseIcon.classList.remove('u-is-hidden')
    this.setAriaDescribedBy()
  }

  pause() {
    this.ui.$video.pause()
    this.isPlaying = false
    this.ui.$playIcon.classList.remove('u-is-hidden')
    this.ui.$pauseIcon.classList.add('u-is-hidden')
    this.setAriaDescribedBy()
  }

  toggle(e) {
    let target = e.target.closest('.js-mute')

    if (this.isMute) {
      this.unmute(target)
    } else {
      this.mute(target)
    }
  }

  unmute() {
    this.ui.$video.muted = false
    this.isMute = false
    this.ui.$muteIcon.classList.add('u-is-hidden')
    this.ui.$unmuteIcon.classList.remove('u-is-hidden')
    this.setAriaDescribedBy()
  }

  mute() {
    this.ui.$video.muted = true
    this.isMute = true
    this.ui.$muteIcon.classList.remove('u-is-hidden')
    this.ui.$unmuteIcon.classList.add('u-is-hidden')
    this.setAriaDescribedBy()
  }

  setAriaDescribedBy() {
    const { play, pause, mute, unmute } = this.controlTitleIds || {}
    if (this.ui.$playBtn && play && pause) {
      this.ui.$playBtn.setAttribute('aria-describedby', this.isPlaying ? pause : play)
    }
    if (!this.ui.$mute || !mute || !unmute) return
    const describedBy = this.ui.$mute.getAttribute('aria-describedby')
    const ref = describedBy && document.getElementById(describedBy.split(/\s+/)[0])
    if (ref && ref.closest && ref.closest('.card__content')) return
    this.ui.$mute.setAttribute('aria-describedby', this.isMute ? mute : unmute)
  }

  decodeHtmlEntities(text) {
    if (!text) return text;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  }

  openTranscript() {
    const description = this.decodeHtmlEntities(this.ui.$video.getAttribute('data-description')) || 'Transcription non disponible.'
    const existingH1 = this.ui.$transcriptContent.querySelector('h1')
    const h1Html = existingH1 ? existingH1.outerHTML : ''
    
    let descriptionDiv = this.ui.$transcriptContent.querySelector('.transcript-popup__text')
    if (descriptionDiv) {
      descriptionDiv.innerHTML = description
    } else {
      descriptionDiv = document.createElement('div')
      descriptionDiv.className = 'transcript-popup__text wysiwyg body-s'
      descriptionDiv.innerHTML = description
      this.ui.$transcriptContent.appendChild(descriptionDiv)
    }
    
    this.ui.$transcriptContent.innerHTML = h1Html + descriptionDiv.outerHTML
    
    this.ui.$transcriptPopup.removeAttribute('hidden')
    this.ui.$transcriptPopup.classList.remove('animate-out')
    this.ui.$transcriptPopup.classList.add('animate-in')
    this.ui.$transcriptBtn.classList.add('is-active')

    const allFocusableElements = document.querySelectorAll('a, button')
    allFocusableElements.forEach(el => {
      if (!el.closest('.js-transcript-popup')) {
        el.tabIndex = -1
      }
    })

    const transcriptFocusableElements = this.ui.$transcriptPopup.querySelectorAll('button')
    transcriptFocusableElements.forEach(el => {
      el.tabIndex = 0
    })

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        this.closeTranscript()
      }
      if (e.key === 'Tab') {
        const currentIndex = Array.from(transcriptFocusableElements).indexOf(document.activeElement)
        
        if (e.shiftKey) {
          if (currentIndex === 0) {
            e.preventDefault()
            transcriptFocusableElements[transcriptFocusableElements.length - 1].focus()
          }
        } else {
          if (currentIndex === transcriptFocusableElements.length - 1) {
            e.preventDefault()
            transcriptFocusableElements[0].focus()
          }
        }
      }
    }

    if (this._transcriptKeyDownHandler) {
      this.ui.$transcriptPopup.removeEventListener('keydown', this._transcriptKeyDownHandler)
    }

    this.ui.$transcriptPopup.addEventListener('keydown', handleKeyDown)
    this._transcriptKeyDownHandler = handleKeyDown

    setTimeout(() => {
      const firstFocusableElement = this.ui.$transcriptPopup.querySelector('button')
      if (firstFocusableElement) {
        firstFocusableElement.focus()
      }
    }, 0)

  }

  closeTranscript() {
    this.ui.$transcriptBtn.classList.remove('is-active')
    this.ui.$transcriptPopup.classList.remove('animate-in')
    this.ui.$transcriptPopup.classList.add('animate-out')
    
    if (this._transcriptKeyDownHandler) {
      this.ui.$transcriptPopup.removeEventListener('keydown', this._transcriptKeyDownHandler)
      this._transcriptKeyDownHandler = null
    }
    
    const allFocusableElements = document.querySelectorAll('a, button')
    allFocusableElements.forEach(el => {
      el.tabIndex = 0
    })

    const onTransitionEnd = () => {
      this.ui.$transcriptPopup.classList.remove('animate-out')
      this.ui.$transcriptPopup.setAttribute('hidden', '')
      this.ui.$transcriptPopup.removeEventListener('transitionend', onTransitionEnd)
    }
    this.ui.$transcriptPopup.addEventListener('transitionend', onTransitionEnd)
  }
}

export default Video
